import { api } from './index';

export const listsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getLists: build.query({
      query: ({ lang }) => `/lists?lang=${lang}`,
      providesTags: ['Lists'],
    }),
  }),
});

export const {
  useGetListsQuery,
  useLazyGetListsQuery,
} = listsApi;
